import NotFound from "@/views/NotFound.vue";

export default [
  // if nothing matched redirect to not found. Has to be last entry
  { name: "notfound", path: "/ui/404", component: NotFound },
  { path: "*", redirect: "/ui/404" }
];
